module.exports = __webpack_public_path__ + "static/DSC_9481-57d979c4d3b7e46a8ea9b62f37f4e097.jpg";